import { share, takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as fromI18n from '@app/core/i18n/store/reducers';
import { Register, RegisterForm, PopinAuthShowed } from '@app/core/user/store/actions';
import * as reducers from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { logger } from 'codelyzer/util/logger';
import { Credentials, UserCreate, NewsletterSubscribersService } from '@vestiaire/api-sdk-angular';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';

@Component({
  selector: 'vc-form-register-validation',
  templateUrl: './form-register-validation.component.html',
  styleUrls: ['./form-register-validation.component.scss']
})
export class FormRegisterValidationComponent implements OnInit, OnDestroy {
  @Input()
  credentials: Credentials;
  @Input()
  popinForced: boolean;
  @Input()
  credentialFirstname: string;

  ngUnsubscribe = new Subject();

  public isMobile = false;

  public displayPassword = false;

  public pending$: Observable<any>;
  public error: string;

  public registerForm: FormGroup;
  public firstname: FormControl;
  public password: FormControl;
  public cgv: FormControl;
  public opted: FormControl;
  public registerCgu = new FormControl('');
  public email: FormControl;

  public currentCountry: any;

  public isSocialRegistration: boolean;

  constructor(
    private ref: ChangeDetectorRef,
    private store: Store<IAppState>,
    private helperService: HelpersService,
    private newsletterSubscribersService: NewsletterSubscribersService
  ) {}

  ngOnInit() {
    this.store.dispatch(new RegisterForm());

    this.isSocialRegistration =
      this.credentials?.socialAccountType && this.credentials?.socialAccountType === 'facebook';

    this.pending$ = this.store.pipe(select(reducers.isPending), share());

    this.store.pipe(select(fromI18n.getUserCountry)).subscribe(
      res => {
        this.currentCountry = res;
      },
      err => {
        logger.info('fromI18n.getUserCountry is not set on subscribe store', err);
      }
    );

    this.createFormControls();
    this.createForm();
    this.error = null;

    this.store.pipe(select(reducers.getError)).subscribe(
      error => {
        if (error && error.error && error.error.errors && error.error.errors.detail) {
          this.error = error.error.errors.detail;
        }
      },
      err => {}
    );
    this.isMobile = !this.helperService.device.isMdUp();
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'registration',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  createFormControls() {
    this.firstname = new FormControl('', [Validators.required]);
    this.cgv = new FormControl(false);
    this.opted = new FormControl(false);
    this.email = new FormControl({ value: this.credentials?.email, disabled: true }, [Validators.required]);

    if (!this.isSocialRegistration) {
      this.password = new FormControl('', [Validators.required]);
    }
  }

  createForm() {
    const formGroupConfig = {
      firstname: this.firstname,
      cgv: this.cgv,
      opted: this.opted,
      email: this.email
    };

    if (!this.isSocialRegistration) {
      formGroupConfig['password'] = this.password;
    }

    this.registerForm = new FormGroup(formGroupConfig);

    this.registerForm.patchValue({
      firstname: this.credentialFirstname ? this.credentialFirstname : ''
    });
  }

  onSubmit() {
    if (this.registerForm.valid) {
      if (!this.isSocialRegistration) {
        this.credentials.password = this.password.value;
      }

      const payload: UserCreate = {
        firstname: this.firstname.value,
        civility: 2,
        country: this.currentCountry.isoCode,
        credentials: this.credentials
      };

      if (this.opted.value) {
        this.newsletterSubscribersService
          .subscribeNewsletter({ email: this.credentials.email, opted: this.opted.value })
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: () => {
              this.store.dispatch(new Register(payload));
              this.ref.detectChanges();
            },
            error: httpErrorRes => (this.error = httpErrorRes.error.errors.detail)
          });
      } else {
        this.store.dispatch(new Register(payload));
        this.ref.detectChanges();
      }
    }
  }

  togglePassword() {
    this.displayPassword = !this.displayPassword;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
